import config from "config/config";
import { isFlagEnabled } from "js/utilities";
export async function submitFNOL(contractId, fnolDetails, userId, fnolRequest) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      userId: userId ?? "0",
      contractId: contractId,
      fnolDetails: !isFlagEnabled("ENABLE_FNOL_NEW_FLOW") ? fnolDetails : "",
      fnolRequest: fnolRequest,
    }),
  };
  const response = await fetch(
    config.REG_API_BASE_URL + "/User/submitfnol",
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
